import { render, staticRenderFns } from "./tableImage.vue?vue&type=template&id=1c107cd2&scoped=true&"
import script from "./tableImage.vue?vue&type=script&lang=js&"
export * from "./tableImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c107cd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/Temperature/TempAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c107cd2')) {
      api.createRecord('1c107cd2', component.options)
    } else {
      api.reload('1c107cd2', component.options)
    }
    module.hot.accept("./tableImage.vue?vue&type=template&id=1c107cd2&scoped=true&", function () {
      api.rerender('1c107cd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rw/tempTable/components/tableImage.vue"
export default component.exports